import {
  ImStudentRegentsExemptions,
  ICourseForRegentsExemption,
} from './../../../../../shared/static-models/im-models/im-student-regents-exemptions';
import * as angular from 'angular';
import * as _ from 'lodash';
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { ISchoolSupport } from 'Src/ng2/shared/typings/interfaces/support.interface';
import { NextRegentsAdminDate } from '../../../../../../ng2/shared/constants/next-regents-admin-date.constant';
import { RegentsPlans, ValidRegentsPlans } from '../../../../../../ng2/shared/constants/regents-plans.constant';
import { RegentsRecommendation } from '../../../../../../ng2/shared/constants/regents-recommendation.constant';
import { RegentsExam, RegentsSubject } from '../../../../../../ng2/shared/constants/regents.constant';
import { SupportCategories } from '../../../../../../ng2/shared/constants/support-categories.constant';
import { ImStudent } from '../../../../../../ng2/shared/services/im-models/im-student.service';
import { ImStudentCurrentProgramHelpers } from '../../../../../shared/static-models/im-models/im-student-current-program-helpers';
import { ImStudentRegents } from '../../../../../shared/static-models/im-models/im-student-regents';
import { AssignSupportModalService } from './../../../../../../ng2/shared/modals/assign-support/assign-support-modal.service';
import { ModalsService } from './../../../../../../ng2/shared/modals/modals.service';
import { RegentsPanelColumns } from './../student-regents-panel.constants';

interface IReview {
  show: boolean;
  tooltipInternalBody: any[];
}

interface IExamName {
  name: string;
  language: string;
}

interface IAttInfoItem {
  date: string;
  cssClass: string;
}

interface INextSchedDropDown {
  options: string;
  examKey: string;
  fieldPath: string;
  offered: boolean;
  disabled: boolean;
  isScheduled: boolean;
  modelFunc: Function;
}

interface ISupportingCourses {
  numOfAlignedCoursesForExam: any;
  tooltipExternalBody: any;
  tooltipInternalBody: any;
}

interface IInProgressForExemptionTooltip {
  count: number;
  tooltipExternalBody: string;
  tooltipInternalBody: ICourseForRegentsExemption[];
}

interface IAdditionalSuppts {
  studentSupportsForExam?: Array<{
    _id: any;
    supportName: any;
  }>;
  showEditIcon?: any;
}

type TStarsSchedStatus = 'Yes' | 'Yes (91)' | 'Yes (92)' | 'No';

interface IRow {
  examKey: string;
  review: IReview;
  category: string;
  examName: IExamName;
  attemptsCount: number;
  attemptsInfo: IAttInfoItem[];
  mostRecentAttempt: string;
  maxScore: IAttInfoItem;
  exemptionStatus: string;
  recommendation: string;
  recommendationRationale: string[];
  nextScheduled: INextSchedDropDown;
  scheduledInStars: TStarsSchedStatus;
  inProgressForExemption: IInProgressForExemptionTooltip;
  supportingCourses: ISupportingCourses;
  additionalSupports: IAdditionalSuppts;
  isScheduled: boolean;
  examDetails: string;
  alignedCoursesForExam: any[];
  offered: boolean;
  maxScoreCellCssClass: string;
  needsSchedInStars: boolean;
}

export class StudentRegentsPanelCtrl {
  static $inject = [
    'StudentSupportModal',
    'UtilitiesService',
    'RegentsNextAdminConflictModal',
    '$scope',
    '$mdMenu',
    'LoteSchedulerModal',
    'ImStudentRegents',
    'ImStudent',
    'DateHelpers',
    'ModalsService',
    'AssignSupportModalService',
    'ImStudentRegentsExemptions',
  ];

  // Bindings
  private student;
  private school;
  private studentSupports;
  private schedExamsNotInStars;
  private schedExamsWithNoSupport;
  private hideSchedInStars;
  private saveStudent;
  private isPlannedDiplomaTypeByCat5OrByCat9;

  // For controller
  private scheduledRegentsValidAdminDates = _.values(ValidRegentsPlans); // contains just dates
  private scheduledRegentsDropdownOptions = _.values(RegentsPlans).concat(''); // contains dates, 'DROP', and ''
  private regentsExamsNoLongerOffered;
  private regentsExamsWithNextAdmin;

  // For template
  public isRestricted;
  public activeSort;
  public reverseSort;
  public cachedSort;
  public regentDetailsByExam;
  public rows: IRow[];
  public headers: string[];
  public plannedDiplomaType;

  constructor(
    private StudentSupportModal,
    private utils: UtilitiesService,
    private RegentsNextAdminConflictModal,
    private $scope,
    private $mdMenu,
    private LoteSchedulerModal,
    private imStudentRegents: ImStudentRegents,
    private ImStudent: ImStudent,
    private DateHelpers,
    private modalsService: ModalsService,
    private assignSupportModalService: AssignSupportModalService,
    private imStudentRegentsExemptions: ImStudentRegentsExemptions,
  ) {}

  $onInit() {
    this.regentsExamsNoLongerOffered = _.map(_.filter(RegentsExam, { isOffered: false }), 'key');
    this.regentsExamsWithNextAdmin = _.filter(RegentsExam, exam => {
      // if this is null that means the exam is NOT offered in the next admin
      // if this is 'Schedule Unknown' it means that the exam is offered but we don't know the date and time yet
      const nextAdminDayTime = exam.nextAdminDates[0];
      if (!nextAdminDayTime) return false;
      return true;
    });

    this.plannedDiplomaType = this.student.gradPlanningDetails.plannedDiplomaType;

    // sorting
    this.activeSort = 'examName';
    this.reverseSort = false;
    this.cachedSort = {};

    this.regentDetailsByExam = this._getRegentDetailsByExam();
    this._setIsPlannedDiplomaTypeByCat5OrByCat9();
    this._setHeaders();
    this._setRows();
    this.sortBy();

    this.$scope.$watch(
      () => this.student.nextScheduledRegents,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.updateTable();
        }
      },
      true,
    );

    this.$scope.$watch(
      () => this.studentSupports,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.updateTable();
        }
      },
      true,
    );

    this.$scope.$watch(
      () => this.student.gradPlanningDetails,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.updateTable();
        }
      },
      true,
    );

    this.$scope.hover = function($event) {
      const tooltipEle = document.getElementsByClassName('nv-tooltip');
      if (tooltipEle.length === 1) {
        tooltipEle[0].setAttribute(
          'style',
          'position:fixed; top:' + ($event.y + 25) + 'px; left:' + ($event.x - 20) + 'px',
        );
      }
    };
  }

  closeMenu() {
    this.$mdMenu.hide();
  }

  _setRows() {
    const copiedByExam = _.cloneDeep(this.student.regentsDetails.byExam);
    const rows = _.reduce(
      this.regentDetailsByExam,
      (acc, examDetails: any) => {
        const { examKey, isOffered, discontinuedSiblings, transcript } = examDetails;
        const { NEXT_SCHEDULED, RECOMMENDATION } = RegentsPanelColumns;

        if (isOffered) {
          const nextScheduledFieldPath = `${NEXT_SCHEDULED.parentPath}.${examKey}.${NEXT_SCHEDULED.childPath}`;
          const examLanguage = this.student.nextScheduledRegents[examKey].examLanguage;
          const examName = {
            display: examDetails.displayName,
            name: examDetails.humanName,
            language: this.LoteSchedulerModal.getFormattedExamName(examLanguage),
          };
          const category = this._getRegentsCat(examKey);
          const attemptsCount = this._getAttemptsTotal(transcript);
          const attemptsInfo = this._getAttemptsInfo(
            copiedByExam,
            examKey,
            discontinuedSiblings,
            examDetails.humanName,
          );
          const mostRecentAttempt = this.imStudentRegentsExemptions.mostRecentRegentsAttemptByExam(
            this.student,
            examKey,
          );
          const maxScore = this._getMaxScore(attemptsInfo);
          const maxScoreNum = maxScore.num;
          const exemptionStatus = this.imStudentRegentsExemptions.exemptionStatusByExam(this.student, examKey);
          const recommendation = this.utils.getFieldByPath(examDetails, RECOMMENDATION.childPath);
          const recommendationRationale = _.map(
            examDetails.recommendationRationale,
            (rationale: string) => RegentsRecommendation[rationale],
          );
          const nextScheduleWithDropdown = this._createDropDown(
            this.scheduledRegentsDropdownOptions,
            examKey,
            examName.name,
            nextScheduledFieldPath,
            recommendation,
          );
          const scheduledInStars = this._getSchedInStarsStatus(this.student, examKey);
          const inProgressForExemption = this.imStudentRegentsExemptions.coursesForExemptionByExam(
            this.student,
            examKey,
          );
          const inProgressForExemptionTooltip = this.createInProgressForExemptionTooltip(inProgressForExemption);
          const alignedCoursesForExam = this.imStudentRegents.getAlignedCoursesForRegentsExam(
            this.student,
            this.school,
            examKey,
          );
          const alignedCoursesForExamWithToolTip = this._createAlignedCoursesTooltip(alignedCoursesForExam);
          const additionalSupports = this._getAdditionalSupportsForExam(examKey);
          const reviewFlagAndToolTip = this._createNeedsReviewFlagAndToolTip(
            examKey,
            recommendation,
            alignedCoursesForExam,
            additionalSupports.studentSupportsForExam,
            scheduledInStars,
          );

          const row: Partial<IRow> = {
            review: reviewFlagAndToolTip,
            category,
            examName,
            attemptsCount,
            attemptsInfo,
            mostRecentAttempt,
            maxScore,
            exemptionStatus,
            recommendation,
            recommendationRationale,
            nextScheduled: nextScheduleWithDropdown,
            scheduledInStars,
            inProgressForExemption: inProgressForExemptionTooltip,
            supportingCourses: alignedCoursesForExamWithToolTip,
            additionalSupports,
          };

          // non column row properties
          row.examKey = examKey;
          row.isScheduled = nextScheduleWithDropdown.isScheduled;
          row.examDetails = examDetails;
          row.alignedCoursesForExam = alignedCoursesForExam;
          row.offered = nextScheduleWithDropdown.offered;
          row.maxScoreCellCssClass = this._getScoreCellCssClass(examKey, maxScoreNum);
          row.needsSchedInStars = scheduledInStars === 'No';

          acc.push(row);
        }

        return acc;
      },
      [],
    );

    this.rows = rows;
  }

  sortBy(columnName?) {
    const { rows } = this;

    if (columnName !== 'cachedSort') {
      if (columnName) {
        const newActiveSortExists = this.activeSort !== columnName;

        if (newActiveSortExists) {
          this.activeSort = columnName;
          this.reverseSort = false;
        } else {
          this.reverseSort = !this.reverseSort;
        }
      } else {
        columnName = this.activeSort;
      }
    }

    rows.sort((row1, row2) => {
      let a;
      let b;

      if (columnName === 'examName') {
        const row1ExamKey = row1.examKey;
        const row2ExamKey = row2.examKey;
        a = _.find(RegentsExam, { key: row1ExamKey }).order;
        b = _.find(RegentsExam, { key: row2ExamKey }).order;
      } else if (columnName === 'maxScore') {
        a = row1.maxScore.num || 0;
        b = row2.maxScore.num || 0;
      } else if (columnName === 'recommendation') {
        a = this.DateHelpers.getMomentObjForMonthYearDate(row1.recommendation).toDate();
        b = this.DateHelpers.getMomentObjForMonthYearDate(row2.recommendation).toDate();
      } else if (columnName === 'nextScheduled' || columnName === 'recommendation') {
        let row1Val;
        let row2Val;

        if (columnName === 'nextScheduled') {
          row1Val = row1.nextScheduled.modelFunc() || '';
          row2Val = row2.nextScheduled.modelFunc() || '';
        } else {
          row1Val = row1.recommendation || '';
          row2Val = row2.recommendation || '';
        }

        const row1DateObj = this._getNextAdminOrRecDateObj(row1Val);
        const row2DateObj = this._getNextAdminOrRecDateObj(row2Val);

        if (!row1DateObj && !row2DateObj) {
          // if both are not dates, compare using nextAdmin data type
          a = row1Val;
          b = row2Val;
        } else {
          // if at least one nextAdmin is a date, coerce nextAdmin to dates
          a = row1DateObj || new Date(null); // Unix epoch
          b = row2DateObj || new Date(null); // Unix epoch
        }
      } else if (columnName === 'attemptsCount') {
        // number types
        a = row1[columnName] || 0;
        b = row2[columnName] || 0;
      } else if (columnName === 'mostRecentAttempt' || columnName === 'exemptionStatus') {
        a = row1[columnName] || '';
        b = row2[columnName] || '';
      } else if (columnName === 'inProgressForExemption') {
        const row1TooltipExternalBody = row1.inProgressForExemption.tooltipExternalBody;
        const row2TooltipExternalBody = row2.inProgressForExemption.tooltipExternalBody;

        a = row1TooltipExternalBody ? row1TooltipExternalBody.toLowerCase() : '';
        b = row2TooltipExternalBody ? row2TooltipExternalBody.toLowerCase() : '';
      } else if (columnName === 'supportingCourses') {
        const row1TooltipExternalBody = row1.supportingCourses.tooltipExternalBody;
        const row2TooltipExternalBody = row2.supportingCourses.tooltipExternalBody;

        a = row1TooltipExternalBody ? row1TooltipExternalBody.toLowerCase() : '';
        b = row2TooltipExternalBody ? row2TooltipExternalBody.toLowerCase() : '';
      } else if (columnName === 'additionalSupports') {
        let row1AdditionalSupportsCount = row1.additionalSupports.studentSupportsForExam.length;
        let row2AdditionalSupportsCount = row2.additionalSupports.studentSupportsForExam.length;

        // .5 is arbitrary number < 1 to make sorting on 'ASSIGN' work
        const row1IsOffered = !row1AdditionalSupportsCount && row1.additionalSupports.showEditIcon && row1.offered;
        if (row1IsOffered) row1AdditionalSupportsCount = 0.5;
        const row2IsOffered = !row2AdditionalSupportsCount && row2.additionalSupports.showEditIcon && row2.offered;
        if (row2IsOffered) row2AdditionalSupportsCount = 0.5;

        a = row1AdditionalSupportsCount;
        b = row2AdditionalSupportsCount;
      } else if (columnName === 'cachedSort') {
        a = this.cachedSort[row1.examKey];
        b = this.cachedSort[row2.examKey];
      } else {
        // string types
        const row1Col = row1[columnName];
        const row2Col = row2[columnName];
        a = row1Col ? row1Col.toLowerCase() : '';
        b = row2Col ? row2Col.toLowerCase() : '';
      }

      if (this.reverseSort) {
        if (a > b) return -1;
        if (a < b) return 1;
      } else {
        if (a < b) return -1;
        if (a > b) return 1;
      }

      return 0;
    });

    // sort cache to restore row order on table update
    _.each(this.rows, (row, indx) => {
      const { examKey } = row;

      this.cachedSort[examKey] = indx + 1;
    });
  }

  updateTable() {
    this.schedExamsNotInStars.count = 0;
    this.schedExamsWithNoSupport.count = 0;

    this._setIsPlannedDiplomaTypeByCat5OrByCat9();
    this._setRows();
    this.sortBy('cachedSort');
  }

  // Used in `Recommendation` header
  acceptRecommendations() {
    const nextScheduledRegents = this.student.nextScheduledRegents;
    let changesMade = false;
    let patch;

    _.forEach(this.regentDetailsByExam, (examDetails: any) => {
      const examKey = examDetails.examKey;
      const recommendation = examDetails.recommendation;

      // no need to process regentsExamsNoLongerOffered
      if (!_.includes(this.regentsExamsNoLongerOffered, examKey)) {
        if (recommendation && _.includes(this.scheduledRegentsDropdownOptions, recommendation)) {
          const nextScheduledRegentsExam = nextScheduledRegents[examKey];

          if (nextScheduledRegentsExam.adminDate !== recommendation) {
            const canExamBeSched = this._canExamBeScheduledForAdminDate(examKey, recommendation);

            if (canExamBeSched.canBeSched) {
              changesMade = true;
            } else {
              this.RegentsNextAdminConflictModal.show(examDetails.humanName, canExamBeSched).then(() => {
                const { NEXT_SCHEDULED } = RegentsPanelColumns;
                const fieldPath = NEXT_SCHEDULED.parentPath + '.' + examKey + '.' + NEXT_SCHEDULED.childPath;

                patch = recommendation;
                this.saveStudent({ patch, fieldPath });
              });
            }
          }
        }
      }
    });

    if (changesMade) return this.saveStudent({ patch, fieldPath: 'nextScheduledRegents' });
  }

  _getCountOfAttemptsForSubjectArea(examTranscriptForRegentsSubject) {
    const count = _.reduce(
      examTranscriptForRegentsSubject,
      (acc, subject: any) => {
        acc += subject.transcript.length;

        return acc;
      },
      0,
    );

    return count;
  }

  _getAttemptsInfo(copiedByExam, examKey, discontinuedSiblings, examName) {
    // if the student has an exam history for an old exam, like old trig which is not displayed in the table, append
    // the old exam history to the new exam history in the tooltip
    // we use the discontinuedSiblings prop on the regents constant to understand if the exam we are looping through
    // has an old exam whose history should be included
    const hasDiscontinuedSiblings = discontinuedSiblings.length > 0;
    const examTranscript = this._formatTranscript(copiedByExam[examKey].transcript, examKey, examName);
    let fullTranscript = examTranscript;
    if (hasDiscontinuedSiblings) {
      _.forEach(discontinuedSiblings, siblingExamKey => {
        const examDetails = _.find(RegentsExam, { key: siblingExamKey });
        const examName = examDetails ? examDetails.humanName : '';
        const examTranscript = this._formatTranscript(copiedByExam[siblingExamKey].transcript, examKey, examName);
        fullTranscript.concat(examTranscript);
      });
    }
    fullTranscript.sort((attempt1, attempt2) => {
      const a = this._getAttemptsDateObj(attempt1);
      const b = this._getAttemptsDateObj(attempt2);

      if (a > b) return -1;
      if (a < b) return 1;
      return 0;
    });

    return fullTranscript;
  }

  _formatTranscript(transcript, examKey, examName) {
    return _.map(transcript, attempt => {
      const { month, year } = attempt;
      const { string, num } = attempt.mark;
      const date = `${month} ${year}`;
      const exam = examName;
      const cssClass = this._getScoreCellCssClass(examKey, string);
      const transcriptForExam = { exam, examKey, month, year, date, cssClass, string, num };
      return transcriptForExam;
    });
  }

  _getAttemptsTotal(attemptsInfo) {
    let count = 0;
    _.each(attemptsInfo, (attempt: any) => {
      if (attempt.mark.string !== 'ABS') {
        count++;
      }
    });
    return count;
  }

  _getMaxScore(attemptsInfo) {
    let maxAttempt = {
      exam: null,
      examKey: null,
      month: null,
      year: null,
      date: null,
      cssClass: null,
      string: null,
      num: null,
    };
    let maxScoreString;
    let maxScoreNum;
    let examKeyWithMaxScore;
    let maxScoreMonth;
    let maxScoreYear;

    _.each(attemptsInfo, (attempt: any) => {
      const { examKey, num, string, month, year } = attempt;

      if (!maxScoreString) {
        examKeyWithMaxScore = examKey;
        maxScoreString = string;
        maxScoreNum = num;
        maxScoreMonth = month;
        maxScoreYear = year;
        maxAttempt = attempt;
      } else if (num > maxScoreNum) {
        examKeyWithMaxScore = examKey;
        maxScoreString = string;
        maxScoreNum = num;
        maxScoreMonth = month;
        maxScoreYear = year;
        maxAttempt = attempt;
      } else if (num === maxScoreNum) {
        // get latest date if scores are the same
        const attemptDateObj = this._getAttemptsDateObj(attempt);
        const maxScoreDateObj = this._getAttemptsDateObj({
          month: maxScoreMonth,
          year: maxScoreYear,
        });

        if (attemptDateObj >= maxScoreDateObj) {
          examKeyWithMaxScore = examKey;
          maxScoreString = string;
          maxScoreNum = num;
          maxScoreMonth = month;
          maxScoreYear = year;
          maxAttempt = attempt;
        }
      }
    });

    if (maxScoreString) {
      const { isOffered, humanName } = _.find(RegentsExam, { key: examKeyWithMaxScore });
      maxAttempt.string = maxScoreString;
      maxAttempt.num = maxScoreNum;

      if (!isOffered) {
        // if an exam is no longer offered, so show the exam name
        maxAttempt.exam = humanName;
      }
    }

    return maxAttempt;
  }

  _getAttemptsDateObj(attempt) {
    const { month, year } = attempt;

    if (month && year) {
      const _year = year.substring(2, 4) + year.substring(7, 9);
      const date = `${month} ${_year}`; // e.g 'Aug SY2017-18'

      return this.DateHelpers.getMomentObjForMonthYearDate(date).toDate();
    }

    return new Date(null); // returns Unix epoch
  }

  _getNextAdminOrRecDateObj(nextAdminDate) {
    if (nextAdminDate) {
      const { length } = nextAdminDate;
      const start = length - 4;
      const year = nextAdminDate.substring(start, length);
      const numType = !isNaN(parseInt(year));

      if (numType) {
        return this.DateHelpers.getMomentObjForMonthYearDate(nextAdminDate).toDate();
      }
    }

    return null; // returns null if nextAdminDate a date
  }

  _getSchedInStarsStatus(student, examKey): TStarsSchedStatus {
    const status = this.imStudentRegentsExemptions.scheduledInStarsStatus(student, examKey);
    const adminDate = student.nextScheduledRegents[examKey].adminDate;

    if (status) return status;
    if (adminDate === NextRegentsAdminDate) {
      return 'No';
    }

    return null;
  }

  _canExamBeScheduledForAdminDate(examKey, adminDate) {
    const result = {
      canBeSched: false,
      conflictingExams: [],
    };

    // there are limitations to scheduling a regents only for next admin dates
    if (adminDate === NextRegentsAdminDate) {
      const regentsExam: any = _.find(this.regentsExamsWithNextAdmin, { key: examKey });
      const nextScheduledRegents = this.student.nextScheduledRegents;

      if (!regentsExam) {
        result.canBeSched = false; // regents exam does not have a next admin, so it cannot be sched
      } else {
        const regentsExamsWithConflictingAdminDates = _.filter(this.regentsExamsWithNextAdmin, (exam: any) => {
          // dont check for conflicts if the exam schedule hasn't been released yet!
          if (regentsExam.nextAdminDates[0] === 'Schedule Unknown') return false;

          // otherwise check for conflicts!
          if (_.intersection(regentsExam.nextAdminDates, exam.nextAdminDates).length && exam.key !== examKey) {
            if (nextScheduledRegents[exam.key].adminDate === NextRegentsAdminDate) {
              return true; // cannot be scheduled
            }
            return false;
          }
        });

        result.canBeSched = regentsExamsWithConflictingAdminDates.length ? false : true;
        result.conflictingExams = result.conflictingExams.concat(regentsExamsWithConflictingAdminDates);
      }
    } else if (_.includes(this.scheduledRegentsDropdownOptions, adminDate)) {
      result.canBeSched = true;
    }

    return result;
  }

  // Used `Additional Supports` column
  openStudentSupportModal(examKey, studentSupportId?) {
    const { _id: studentId } = this.student;
    const { _id: schoolId } = this.school;
    const editSupport = !!studentSupportId;
    let promise;

    if (editSupport) {
      promise = this.StudentSupportModal.show(this.school._id, this.student._id, studentSupportId);
    } else {
      // This utilizes the v3 Assign Support modal
      const category = 'REGENTS_PREP';
      const {
        subject: { key },
      } = _.find(RegentsExam, { key: examKey });

      this.modalsService
        .openAssignSupportModal({
          schoolId,
          studentIds: [studentId],
          category,
          examSubjectKey: key,
        })
        .afterClosed()
        .subscribe((selectedSupport: ISchoolSupport) => {
          // If !selectedSupport, then the user canceled action in modal (CM).
          if (selectedSupport) {
            this.assignSupportModalService.createStudentSupport({
              support: selectedSupport,
              studentId,
              schoolId,
            });
          }
        });
    }
  }

  _setHeaders() {
    this.headers = [
      RegentsPanelColumns.REVIEW.humanName,
      RegentsPanelColumns.EXAM_NAME.humanName,
      RegentsPanelColumns.ATTEMPTS.humanName,
      RegentsPanelColumns.MAX_SCORE.humanName,
      RegentsPanelColumns.RECOMMENDATION.humanName,
      RegentsPanelColumns.NEXT_SCHEDULED.humanName,
      RegentsPanelColumns.SCHEDULED_IN_STARS.humanName,
      RegentsPanelColumns.SUPPORTING_COURSES.humanName,
      RegentsPanelColumns.ADDITIONAL_SUPPORTS.humanName,
    ];
  }

  _setIsPlannedDiplomaTypeByCat5OrByCat9() {
    this.isPlannedDiplomaTypeByCat5OrByCat9 = this.ImStudent.isPlannedDiplomaTypeByCat5OrByCat9(this.student);
  }

  _getRegentsCat(examKey) {
    const type = this.isPlannedDiplomaTypeByCat5OrByCat9;
    return _.find(RegentsExam, { key: examKey }).category[type].humanName;
  }

  _getRegentDetailsByExam() {
    const copiedByExam = _.cloneDeep(this.student.regentsDetails.byExam);

    const regentDetailsByExam = _.map(copiedByExam, (examDetails: any, examKey: string) => {
      const regentsExam = _.find(RegentsExam, { key: examKey });
      examDetails.examKey = examKey;
      examDetails.discontinuedSiblings = regentsExam.discontinuedSiblings;
      examDetails.displayName = regentsExam.humanNameForSsvRegentsPanelTable || regentsExam.humanName;
      examDetails.humanName = regentsExam.humanName;
      examDetails.order = regentsExam.order;
      examDetails.isOffered = regentsExam.isOffered;
      examDetails.subject = regentsExam.subject;

      return examDetails;
    });

    return regentDetailsByExam;
  }

  _createNeedsReviewFlagAndToolTip(examKey, recommendation, supportingCourses, additionalSupports, scheduledInStars) {
    const flag = {
      show: false,
      tooltipInternalBody: [],
    };

    // no need to process regentsExamsNoLongerOffered
    if (!_.includes(this.regentsExamsNoLongerOffered, examKey) && recommendation !== 'Not Eligible') {
      const nextScheduled = this.student.nextScheduledRegents[examKey].adminDate;
      const conflictsForNextAdmin = this._canExamBeScheduledForAdminDate(examKey, nextScheduled);
      const plannedGraduationDate = this.student.gradPlanningDetails.plannedGraduationDate;

      if (nextScheduled === NextRegentsAdminDate) {
        if (!supportingCourses.length && !additionalSupports.length) {
          flag.show = true;
          flag.tooltipInternalBody.push('Student scheduled for next admin, but has no support.');

          this.schedExamsWithNoSupport.count++;
        }

        if (!this.hideSchedInStars && scheduledInStars === 'No') {
          flag.show = true;
          flag.tooltipInternalBody.push('Student scheduled for next admin, but not scheduled in STARS.');

          this.schedExamsNotInStars.count++;
        }

        if (!conflictsForNextAdmin.canBeSched) {
          flag.show = true;
          if (conflictsForNextAdmin.conflictingExams.length) {
            // tslint:disable-next-line:max-line-length
            flag.tooltipInternalBody.push(
              `This exam is offered for ${NextRegentsAdminDate}. However, the student is already scheduled for an exam being administered simultaneously (${
                conflictsForNextAdmin.conflictingExams[0].humanName
              }).`,
            );
          } else {
            // tslint:disable-next-line:max-line-length
            flag.tooltipInternalBody.push(
              `This exam is scheduled for but is not offered in the ${NextRegentsAdminDate} administration.`,
            );
          }
        }
      }

      if (plannedGraduationDate) {
        const gradDateMoment = this.DateHelpers.getMomentObjForMonthYearDate(plannedGraduationDate);
        const nextScheduledMoment = this.DateHelpers.getMomentObjForMonthYearDate(nextScheduled);

        if (gradDateMoment.isBefore(nextScheduledMoment)) {
          flag.show = true;
          // tslint:disable-next-line:max-line-length
          flag.tooltipInternalBody.push(
            `This exam is scheduled for a date after the planned graduation date of ${plannedGraduationDate}.`,
          );
        }
      } else {
        // projected grad rate for student's with no planned graduation date
        const effectivePlannedGradDate = this.ImStudent.getEffectivePlannedGradDate(this.student);
        const gradDateMoment = this.DateHelpers.getMomentObjForMonthYearDate(effectivePlannedGradDate);
        const nextScheduledMoment = this.DateHelpers.getMomentObjForMonthYearDate(nextScheduled);

        if (gradDateMoment.isBefore(nextScheduledMoment)) {
          flag.show = true;
          // tslint:disable-next-line:max-line-length
          flag.tooltipInternalBody.push(
            `This exam is scheduled for a date after the expected graduation date of ${effectivePlannedGradDate}.`,
          );
        }
      }
    }

    return flag;
  }

  _getScoreCellCssClass(examKey, attempScoreString) {
    const status = this.imStudentRegents.regentsExamPassedStatusBasedOnScoreAndDiplomaType(
      this.student,
      examKey,
      attempScoreString,
      this.plannedDiplomaType,
    );

    if (status.collegeReady) {
      return 'college-ready';
    }

    if (status.passed) {
      return 'passed';
    }

    if (status.passed === false) {
      return 'not-passed';
    }

    return '';
  }

  // Used in `Next Scheduled` column
  _createDropDown(options, examKey, examName, fieldPath, recommendation): INextSchedDropDown {
    const adminDate = this.student.nextScheduledRegents[examKey].adminDate;
    const modelFunc = this._updateNextSchedAdmin(examKey, examName, fieldPath, adminDate);
    let offered = true;
    let isScheduled = false;
    let disabled = false;

    if (_.includes(this.regentsExamsNoLongerOffered, examKey)) {
      offered = false;
    }

    if (_.includes(this.scheduledRegentsValidAdminDates, adminDate)) {
      isScheduled = true;
    }

    if (recommendation === 'Not Eligible') {
      disabled = true;
    }

    return {
      options,
      examKey,
      fieldPath,
      offered,
      disabled,
      isScheduled,
      modelFunc,
    };
  }

  _updateNextSchedAdmin(examKey, examName, fieldPath, adminDate) {
    let nextSchedAdmin;

    if (examKey === 'lote') {
      nextSchedAdmin = this._updateNextSchedAdminLote(examKey, examName);
    } else {
      nextSchedAdmin = this._updateNextSchedAdminNonLote(examKey, examName, adminDate, fieldPath);
    }

    // sort table correctly
    if (_.size(this.cachedSort)) {
      this.sortBy('cachedSort');
    }

    return nextSchedAdmin;
  }

  _updateNextSchedAdminNonLote(examKey, examName, adminDate, fieldPath) {
    if (examKey === 'lote') throw new Error('_updateNextSchedAdminNonLote cannot be called for "lote" exams.');

    // closure
    const nextScheduledRegentsForExam = this.student.nextScheduledRegents[examKey];
    let prevAdminDate = nextScheduledRegentsForExam.adminDate;

    // modelFunc
    return newAdminDate => {
      // for other (including LOTE exams not scheduled for Next Admin)
      if (newAdminDate !== undefined && prevAdminDate !== newAdminDate) {
        const canExamBeSched = this._canExamBeScheduledForAdminDate(examKey, newAdminDate);
        if (canExamBeSched.canBeSched) {
          const patch = newAdminDate;
          return this.saveStudent({ patch, fieldPath });
        } else {
          return this.RegentsNextAdminConflictModal.show(examName, canExamBeSched).then(() => {
            const patch = newAdminDate;
            return this.saveStudent({ patch, fieldPath });
          });
        }
      } else if (!_.includes(this.scheduledRegentsDropdownOptions, prevAdminDate)) {
        return '';
      }

      return prevAdminDate;
    };
  }

  _updateNextSchedAdminLote(examKey, examName) {
    if (examKey !== 'lote') throw new Error('_updateNextSchedAdminLote can only be called for "lote" exams.');

    // closure
    const nextScheduledRegentsForExam = this.student.nextScheduledRegents[examKey];
    const _fieldPath = 'nextScheduledRegents.lote';
    let prevAdminDate = nextScheduledRegentsForExam.adminDate;

    return newAdminDate => {
      if (newAdminDate !== undefined && prevAdminDate !== newAdminDate) {
        if (newAdminDate === '') {
          // make both fields null in this case
          const patch = {
            nextScheduledRegents: {
              lote: {
                adminDate: null,
                examLanguage: null,
              },
            },
          };

          return this.saveStudent({ patch, fieldPath: _fieldPath });
        } else {
          const canExamBeSched = this._canExamBeScheduledForAdminDate(examKey, newAdminDate);

          if (canExamBeSched.canBeSched) {
            return this.LoteSchedulerModal.show(nextScheduledRegentsForExam.examLanguage).then(
              updatedLanguage => {
                const patch = {
                  nextScheduledRegents: {
                    lote: {
                      adminDate: newAdminDate,
                      examLanguage: updatedLanguage,
                    },
                  },
                };
                return this.saveStudent({ patch, fieldPath: _fieldPath });
              },
              () => {
                // Cancel
                return prevAdminDate;
              },
            );
          } else {
            return this.RegentsNextAdminConflictModal.show(examName, canExamBeSched).then(() => {
              const patch = newAdminDate;
              return this.saveStudent({ patch, fieldPath: _fieldPath });
            });
          }
        }
      } else if (!_.includes(this.scheduledRegentsDropdownOptions, prevAdminDate)) {
        return '';
      }

      return prevAdminDate;
    };
  }

  openLoteModal(examKey, examLanguage) {
    if (examKey !== 'lote') {
      throw new Error('$ctrl.openLoteModal can only be called on "lote" regents exams.');
    } else {
      const fieldPath = 'nextScheduledRegents.lote.examLanguage';

      return this.LoteSchedulerModal.show(examLanguage).then(updatedLanguage => {
        // Confirm
        if (examLanguage !== updatedLanguage) {
          const patch = updatedLanguage;
          return this.saveStudent({ patch, fieldPath });
        }
      });
    }
  }

  // Used in `Supporting Courses` column
  _createAlignedCoursesTooltip(alignedCoursesForExam) {
    const numOfAlignedCoursesForExam = alignedCoursesForExam.length;
    let tooltipExternalBody;
    let tooltipInternalBody;

    if (numOfAlignedCoursesForExam === 1) {
      const supportingCourseInfo = this._getSupportingCourseInfo(alignedCoursesForExam[0]);

      tooltipExternalBody = `${alignedCoursesForExam[0].courseCode}-${alignedCoursesForExam[0].section}`;
      tooltipInternalBody = [supportingCourseInfo];
    } else if (numOfAlignedCoursesForExam > 1) {
      tooltipExternalBody = `${numOfAlignedCoursesForExam} Courses`;
      tooltipInternalBody = _.map(alignedCoursesForExam, (course: any) => {
        const supportingCourseInfo = this._getSupportingCourseInfo(course);
        const courseCodeAndSection = `${course.courseCode}-${course.section}`;

        return Object.assign({}, { courseCodeAndSection }, supportingCourseInfo);
      });
    }

    return {
      numOfAlignedCoursesForExam,
      tooltipExternalBody,
      tooltipInternalBody,
    };
  }

  private createInProgressForExemptionTooltip(
    coursesForRegentsExemption: ICourseForRegentsExemption[],
  ): IInProgressForExemptionTooltip {
    const count = coursesForRegentsExemption && coursesForRegentsExemption.length;
    let tooltipExternalBody;

    if (count === 1) {
      tooltipExternalBody = coursesForRegentsExemption[0].codeAndSection;
    } else if (count > 1) {
      tooltipExternalBody = `${count} Courses`;
    }

    return {
      count,
      tooltipExternalBody,
      tooltipInternalBody: coursesForRegentsExemption,
    };
  }

  _getSupportingCourseInfo(alignedCourseForExam) {
    const { courseName, teachers, marks, priority } = alignedCourseForExam;
    const joinedTeachers = ImStudentCurrentProgramHelpers.getJoinedTeacherNames(teachers);
    const priorityString = ImStudentCurrentProgramHelpers.getPriorityString(priority);
    let currentGrade;
    let status;

    if (marks.length) {
      const mark = ImStudentCurrentProgramHelpers.getCurrentCourseMark(marks);

      if (mark) {
        currentGrade = mark.string;
        status = ImStudentCurrentProgramHelpers.getGradeStatus(mark);
      } else {
        currentGrade = 'N/A';
        status = 'N/A';
      }
    } else {
      currentGrade = 'N/A';
      status = 'N/A';
    }

    const info = {
      courseName,
      teacher: joinedTeachers,
      currentGrade,
      priority: priorityString,
      status,
    };

    return info;
  }

  // Populates Additional Supports Column
  _getAdditionalSupportsForExam(examKey): IAdditionalSuppts {
    // no need to process regentsExamsNoLongerOffered
    if (_.includes(this.regentsExamsNoLongerOffered, examKey)) return {};

    const isRegentsExamScheduled = this.imStudentRegents.isStudentAdminDateValid(this.student, examKey);

    const regentsSubject = _.find(RegentsSubject, regentsSubject => {
      return _.includes(regentsSubject.exams, _.find(RegentsExam, { key: examKey }));
    });
    const currentlyActiveSupportsForExam = this.ImStudent.getCurrentlyActiveSupports(
      this.student,
      this.studentSupports,
      SupportCategories.REGENTS_PREP.key,
      regentsSubject.key,
    );

    const studentSupportsForExam = _.map(currentlyActiveSupportsForExam, (studentSupport: any) => {
      return {
        _id: studentSupport._id,
        supportName: studentSupport.support.name,
      };
    });

    const additionaSupports = {
      studentSupportsForExam,
      showEditIcon: studentSupportsForExam.length || isRegentsExamScheduled,
    };

    return additionaSupports;
  }
}

angular.module('nv.singleStudent').controller('StudentRegentsPanelTableCtrl', StudentRegentsPanelCtrl);
